import { ChangeDetectorRef, Component, Input } from "@angular/core";
import { DownloadService } from "./download.service";
import { Subscription } from "rxjs";
import { environment } from "../../../../environments/environment";

@Component({
	selector: "app-download",
	templateUrl: "./download.component.html",
})
export class DownloadComponent {
	showDownloadFloating = true;
	private baseUrl = environment.BE_BASE_URL;

	downloadQueue: {
		id: string;
		title: string;
		progress: number;
		status: string;
		jobId: string;
	}[] = [];

	private downloadQueueSubscription: Subscription;
	constructor(
		private downloadService: DownloadService,
		private cdr: ChangeDetectorRef
	) {}

	ngOnInit() {
		// Create a Set to keep track of processed job IDs
		const processedJobIds = new Set();

		// Subscribe to the download queue observable
		this.downloadQueueSubscription =
			this.downloadService.downloadQueue$.subscribe((queue) => {
				this.downloadQueue = queue;

				setTimeout(() => {
					this.downloadQueue.forEach((download) => {
						if (download.status === "Completed" && download.jobId) {
							// Check if the jobId has already been processed
							if (!processedJobIds.has(download.jobId)) {
								const downloadUrl = `${this.baseUrl}/download-excel?jobId=${download.jobId}`;

								// Create an anchor element
								const link = document.createElement("a");
								link.href = downloadUrl;
								link.download = ""; // This attribute prompts the browser to download the file

								// Append the link to the DOM temporarily
								document.body.appendChild(link);

								// Simulate clicking the link to start the download
								link.click();

								// Remove the link after clicking it to clean up
								document.body.removeChild(link);

								// Mark this jobId as processed
								processedJobIds.add(download.jobId);
							}
						}
					});
				}, 2000);

				this.updateProgressManually();
			});
	}

	ngOnDestroy() {
		// Clean up the subscription when the component is destroyed
		if (this.downloadQueueSubscription) {
			this.downloadQueueSubscription.unsubscribe();
		}
	}

	isExpanded = true;

	toggle() {
		this.isExpanded = !this.isExpanded;
	}

	canCloseButtonBeShown(): boolean {
		return this.downloadQueue.every(
			(download) =>
				download.status !== "Waiting for download" &&
				download.status !== "In Progress" &&
				download.status !== "In Queued"
		);
	}

	clearAll(event: MouseEvent) {
		event.stopPropagation(); // Prevent toggle when closing
		this.downloadQueue.length = 0; // Clear the download queue
		this.downloadService.deleteAll();
		this.updateProgressManually();
	}

	updateProgressManually() {
		// When you manually update progress, call this to trigger change detection
		this.cdr.detectChanges();
	}

	allStatusOnChecking() {
		return this.downloadService.allStatusOnChecking() ? true : false;
	}
}
